module.exports = "/assets/data/997eed0dda5b4b141b36155de9a8f545-TN32.data.json";